<template>
  <div>
    <div class="flex flex-wrap-reverse items-center">
      <!-- ADD NEW -->
      <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData()">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Novo</span>
      </div>
    </div>
    <CarrierSidebar
      :isSidebarActive="carrierSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="{carrierToEdit: getCarrierToEdit}" />
    <vue-good-table
      style="width: 100%;"
      styleClass="vgt-table condensed"
      :rows="getCarriers"
      :columns="columns"
      :pagination-options="paginationOptions"
      :search-options="{enabled: true, placeholder: 'Procurar'}">
      <div slot="emptystate" class="text-center">
        Nenhum resultado encontrado
      </div>
      <template slot="table-row" slot-scope="carrier">
        <span class="font-medium" v-if="carrier.column.field == 'endereco'">
          {{carrier.row.endereco}}{{carrier.row.numeroCasa ? ', ' + carrier.row.numeroCasa : ''}}
        </span>
        <span class="font-medium" v-else-if="carrier.column.field == 'ações'">
          <div>
            <feather-icon
              icon="EditIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="editQuote(carrier.row)" />
            <feather-icon
              icon="Trash2Icon"
              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
              @click="deleteQuote(carrier.row)" />
          </div>
        </span>
        <span class="font-medium" v-else>
          {{carrier.formattedRow[carrier.column.field]}}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>
<script>
import helpers from "@/helpers";
import CarrierSidebar from "./CarrierSidebar.vue"

export default {
  data() {
    return {
      carriers: [],
      carrierToEdit: null,
      helpers: null,
      columns: [],
      carrierSidebar: false,
      paginationOptions: {
        enabled: true,
        nextLabel: 'Próxima',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Resultados por página',
        ofLabel: 'de',
        pageLabel: 'Página',
        allLabel: 'Todos',
        mode: 'pages',
        perPage: 15
      }
    };
  },
  components: {
    CarrierSidebar
  },
  computed: {
    getCarriers() {
      return this.$store.state.carriers
    },
    getCarrierToEdit() {
      return this.carrierToEdit
    },
  },
  methods: {
    addNewData() {
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar(val = false) {
      if (val == false)
        this.carrierToEdit = null
      this.carrierSidebar = val;
    },
    mountTable() {
      this.columns = [{
          label: 'Nome Curto',
          field: 'nomeCurto',
        },
        {
          label: 'Razão Social',
          field: 'razaoSocial',
        },
        {
          label: 'CPF/CNPJ',
          field: 'cpfCnpj',
        },
        {
          label: 'Telefone',
          field: 'telefone',
        },
        {
          label: 'Endereço',
          field: 'endereco',
        },
        {
          label: 'Bairro',
          field: 'bairro',
        },
        {
          label: 'Município',
          field: 'cidade',
        },
        {
          label: 'Estado',
          field: 'estado',
        },
        {
          label: 'Ações',
          field: 'ações',
          sortable: false
        },
      ]
    },
    editQuote(carrier) {
      this.carrierToEdit = carrier
      this.toggleDataSidebar(true)
    },
    deleteQuote(id) {
      console.log('deletar: ', id)
    },
  },
  async created() {
    this.helpers = helpers
    const payload = {
      loading: this.$vs.loading
    }
    await this.$store.dispatch("fetchCarriersItems", payload)
    this.mountTable()
  },
};

</script>
<style lang="scss">
table.vgt-table {
  font-size: 1rem;
}

</style>
